"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var BarMoveLeft_exports = {};
__export(BarMoveLeft_exports, {
  default: () => BarMoveLeft_default
});
module.exports = __toCommonJS(BarMoveLeft_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.0664 13.7266C11.2487 13.8958 11.3398 14.1042 11.3398 14.3516C11.3398 14.599 11.2487 14.8138 11.0664 14.9961C10.8971 15.1654 10.6888 15.25 10.4414 15.25C10.207 15.25 9.9987 15.1654 9.81641 14.9961L5.75391 10.875C5.58464 10.7057 5.5 10.4974 5.5 10.25C5.5 10.0026 5.58464 9.79427 5.75391 9.625L9.81641 5.50391C9.9987 5.33464 10.207 5.25 10.4414 5.25C10.6888 5.25 10.8971 5.33464 11.0664 5.50391C11.2487 5.6862 11.3398 5.90104 11.3398 6.14844C11.3398 6.39583 11.2487 6.60417 11.0664 6.77344L7.62891 10.25L11.0664 13.7266ZM14.6602 5.25C14.8945 5.25 15.0898 5.33464 15.2461 5.50391C15.4154 5.66016 15.5 5.85547 15.5 6.08984V14.4102C15.5 14.6445 15.4154 14.8464 15.2461 15.0156C15.0898 15.1719 14.8945 15.25 14.6602 15.25C14.4388 15.25 14.2435 15.1719 14.0742 15.0156C13.918 14.8464 13.8398 14.6445 13.8398 14.4102V6.08984C13.8398 5.85547 13.918 5.66016 14.0742 5.50391C14.2435 5.33464 14.4388 5.25 14.6602 5.25Z",
      fill: "currentColor"
    }
  )
);
const SvgBarMoveLeft = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var BarMoveLeft_default = SvgBarMoveLeft;
